import { render, staticRenderFns } from "./SurveyTabReadOnly.vue?vue&type=template&id=dd589170&"
import script from "./SurveyTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./SurveyTabReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports